import { cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@staff-app/ui';
import type { AgentDeviceStatus } from '../lib/device-status';

/** Live (online/hdmiOff/offline) ∪ lastHeartBeat-fallback (stale) states. */
export type AgentDotStatus = AgentDeviceStatus | 'hdmiOff';

const LABEL: Record<AgentDotStatus, string> = {
  online: 'Online',
  stale: 'Stale',
  hdmiOff: 'HDMI off',
  offline: 'Offline',
};

export function AgentDeviceStatusDot({ status }: { status: AgentDotStatus }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            aria-label={LABEL[status]}
            data-testid="agent-device-status-dot"
            className={cn(
              'inline-block h-2 w-2 rounded-full',
              status === 'online' && 'bg-success',
              (status === 'stale' || status === 'hdmiOff') && 'bg-warning',
              status === 'offline' && 'bg-muted-foreground',
            )}
          />
        </TooltipTrigger>
        <TooltipContent>{LABEL[status]}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
